import * as $ from 'jquery'
import {gsap, ScrollTrigger} from 'gsap/all';
gsap.registerPlugin(ScrollTrigger);

$(document).ready(function () {
	const HPVideo = document.querySelector('.hp-hero-video')
	const HPVideoVolToggle = document.querySelector('.toggle-volume')

	if (HPVideoVolToggle) {
		HPVideoVolToggle.addEventListener('click', function () {
			HPVideoVolToggle.classList.toggle('volume-active')
			HPVideo.muted === true ?
				HPVideo.muted = false :
				HPVideo.muted = true
		})
	}

	const doctorVideo = document.getElementById('doctor-video')

	if (doctorVideo) {
		const trigger = document.querySelector('.doctors-volume-toggle');

		trigger?.addEventListener('click', () => {
			trigger.classList.toggle('volume-active')
			doctorVideo.muted = !doctorVideo.muted;
		})
	}


	$('.open-orders-detail').on('click', function () {
		let number = $(this).data('number');
		$('.orders').hide();
		$('.orders-details').hide();
		$('.orders-details-' + number).show();
	});

	$('.close-orders-detail').on('click', function () {
		$('.orders-details').hide();
		$('.orders').show();
	});

	// account header active class
	$('.account-tab_label').on('click', function () {
		$('.account-tab_label').removeClass('active');
		$(this).addClass('active');
	});

	// active class for header navigation
	$('.nav-first-links a, .nav-second-links a').each(function () {
		let $this = $(this);
		if ($this.attr('href') === window.location.pathname) {
			$this.addClass('nav-active');
		}
	});

	// sign in, reset password (show, hide)
	$('#RecoverPassword').click(function () {
		$('#CustomerLoginForm, #shopify-section-sign-in').hide();
		$('#RecoverPasswordForm').show();
	});

	$('#HideRecoverPasswordLink').click(function () {
		$('#CustomerLoginForm, #shopify-section-sign-in').show();
		$('#RecoverPasswordForm').hide();
	});

	// Home Page Blob
	if ($('.home-hero-blob').length) {
		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: '.home-hero',
				start: 'top+=50 top',
				end: '+=500',
				toggleActions: 'play none none reverse',
				scrub: true
			},
		});

		tl.fromTo('.blob-circle', {
			x: -10
		}, {
			x: -45
		})
	}

	// Banner background change on scroll
	const bannerScrollable = $('.headline-bar').attr('data-scrolling');

	if (typeof bannerScrollable !== 'undefined' && bannerScrollable !== false) {
		$(window).on('scroll', function () {
			let scroll = window.pageYOffset;

			if (scroll > 9000) {
				$('.headline-bar').css('background-color', '#E9CDA5')
			} else if (scroll > 9000) {
				$('.headline-bar').css('background-color', '#AE5A48')
			} else if (scroll > 8100) {
				$('.headline-bar').css('background-color', '#6E3627')
			} else if (scroll > 7200) {
				$('.headline-bar').css('background-color', '#E9CDA5')
			} else if (scroll > 6300) {
				$('.headline-bar').css('background-color', '#AE5A48')
			} else if (scroll > 5400) {
				$('.headline-bar').css('background-color', '#6E3627')
			} else if (scroll > 4500) {
				$('.headline-bar').css('background-color', '#E9CDA5')
			} else if (scroll > 3600) {
				$('.headline-bar').css('background-color', '#AE5A48')
			} else if (scroll > 2700) {
				$('.headline-bar').css('background-color', '#6E3627')
			} else if (scroll > 1800) {
				$('.headline-bar').css('background-color', '#E9CDA5')
			} else if (scroll > 900) {
				$('.headline-bar').css('background-color', '#AE5A48')
			} else {
				$('.headline-bar').css('background-color', '#6E3627')
			}
		});
	}

	// show password
	$('.pass-icon').on('click', function () {
		let type = $(this).parent('.modal-password').find('.primary-inp').get(0).type;
		if (type === 'text') {
			type = 'password';
		} else {
			type = 'text';
		}
		$(this).parent('.modal-password').find('.primary-inp').get(0).type = type;
	});

	$('.quote-item').html(function () {
		// Class or id can be use
		var text = $(this).find('p').text().split(' '); // All text convert to array.
		var last = text.pop(); // Select last word.
		var first = text.shift() // Select first word.

		var firstW = '<em class="firstWord">' + first + '</em>'; // Make wrapper of first word
		var lastW = '<em class="lastWord">' + last + '</em>'; // Make wrapper of last word.

		return '<p>' + firstW + ' ' + text.join(' ').concat(' ' + lastW) + '</p>';
	});

	$('.size-chart-trigger').on('click', function (e) {
		e.stopPropagation()
		$('.size-chart').addClass('d-flex')
	})

	$('.size-chart-close').on('click', function (e) {
		e.stopPropagation()
		$('.size-chart').removeClass('d-flex')
	})

	if ($('.size-chart').length) {
		$(document).on('click', function (e) {
			if (!e.target.closest('.size-chart-container')) {
				$('.size-chart').removeClass('d-flex')
			}
		})
	}
});

export function customSelect () {
	$('.selectric').selectric({
		disableOnMobile: false,
		nativeOnMobile: false,
	})
}
